import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

import logo1 from '../components/assets/clients_logo/logo3.jpg'
import logo2 from '../components/assets/clients_logo/logo4.jpg'
import logo3 from '../components/assets/clients_logo/logo5.jpg'
import logo4 from '../components/assets/clients_logo/logo6.jpg'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Atlas Way Global</title>
        <meta property="og:title" content="Circular Euphoric Goose" />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
        @keyframes slideInLeft {from {opacity: 0;
transform: translateX(-2rem);}
to {opacity: 1;
transform: translateX(0);}}@keyframes slideUp {from {opacity: 0;
transform: translateY(2rem);}
to {opacity: 1;
transform: translateY(0);}}@keyframes fadeIn {from {opacity: 0;}
to {opacity: 1;}}@keyframes scrollPulse {0%,100% {transform: translateY(0);
opacity: 1;}
50% {transform: translateY(1rem);
opacity: 0.3;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="homepage">
(function(){
  // Form submission handler
  const contactForm = document.getElementById("contactForm")

  if (contactForm) {
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault()

      const formData = {
        name: document.getElementById("name").value,
        phone: document.getElementById("phone").value,
        email: document.getElementById("email").value,
        message: document.getElementById("message").value,
      }

      console.log("Form submitted:", formData)

      // Show success message
      alert(
        "Thank you for your inquiry! Our team will contact you within 24 hours."
      )

      // Reset form
      contactForm.reset()
    })
  }

  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -100px 0px",
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  // Observe sections for scroll animations
  const sections = document.querySelectorAll(
    ".about-section, .services-section, .why-choose-section, .clients-section, .contact-section"
  )
  sections.forEach((section) => {
    section.style.opacity = "0"
    section.style.transform = "translateY(2rem)"
    section.style.transition =
      "opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)"
    observer.observe(section)
  })

  // Card hover effect enhancement
  const serviceCards = document.querySelectorAll(".service-card")
  serviceCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      this.style.transition = "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)"
    })
  })

  // Parallax effect for hero video
  let ticking = false
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const heroVideo = document.querySelector(".hero-video")
        if (heroVideo) {
          const scrolled = window.pageYOffset
          const parallax = scrolled * 0.3
          heroVideo.style.transform = \`translate(-50%, calc(-50% + \${parallax}px))\`
        }
        ticking = false
      })
      ticking = true
    }
  })

  // Input focus effects
  const formInputs = document.querySelectorAll(".form-input, .form-textarea")
  formInputs.forEach((input) => {
    input.addEventListener("focus", function () {
      const wrapper = this.closest(
        ".form-input-wrapper, .form-textarea-wrapper"
      )
      if (wrapper) {
        const icon = wrapper.querySelector(".form-input-icon")
        if (icon) {
          icon.style.color = "var(--color-accent)"
          icon.style.transition = "color 0.3s ease"
        }
      }
    })

    input.addEventListener("blur", function () {
      const wrapper = this.closest(
        ".form-input-wrapper, .form-textarea-wrapper"
      )
      if (wrapper) {
        const icon = wrapper.querySelector(".form-input-icon")
        if (icon) {
          icon.style.color = "var(--color-on-surface-secondary)"
        }
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section id="hero" className="hero-section">
        <div className="hero-video-container">
          <video
            autoPlay="true"
            loop="true"
            muted="true"
            playsInline="true"
            poster="https://images.pexels.com/videos/32750421/pictures/preview-0.jpg"
            src="https://videos.pexels.com/video-files/32750421/13962217_640_360_60fps.mp4"
            className="hero-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-text-container">
            <div className="hero-label">
              <span className="hero-label-text">Atlas Way Global</span>
              <div className="hero-label-line"></div>
            </div>
            <h1 className="hero-title">
              Comprehensive Global Logistics Solutions
            </h1>
            <p className="hero-subtitle">
              {' '}
              By Air, Sea, Rail, and Road – ATLAS WAY GLOBAL Gets It Done.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
            <div className="hero-cta-group">
              <button className="btn btn-accent btn-lg">Request a Quote</button>
              <button className="btn btn-lg btn-outline">Learn More</button>
            </div>
          </div>
          <div className="hero-stats">
            <div className="hero-stat-item">
              <div className="hero-stat-number">
                <span>15+</span>
              </div>
              <div className="hero-stat-label">
                <span>Years in Operation</span>
              </div>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat-item">
              <div className="hero-stat-number">
                <span>80+</span>
              </div>
              <div className="hero-stat-label">
                <span>Countries Served</span>
              </div>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat-item">
              <div className="hero-stat-number">
                <span>84K+</span>
              </div>
              <div className="hero-stat-label">
                <span>Shipments Delivered</span>
              </div>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat-item">
              <div className="hero-stat-number">
                <span>98%</span>
              </div>
              <div className="hero-stat-label">
                <span>Client Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-scroll-indicator">
          <div className="scroll-line"></div>
          <span className="scroll-text">SCROLL</span>
        </div>
      </section>
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-content-grid">
            <div className="about-text-block">
              <div className="section-header">
                <span className="section-label">ABOUT AWG</span>
                <h2 className="section-title">
                  Leading Global Logistics Partner
                </h2>
              </div>
              <p className="section-content">
                {' '}
                Atlas Way Global delivers comprehensive, end-to-end logistics
                solutions worldwide. We operate across multiple transport
                channels, including air, sea, rail, and road, ensuring
                flexibility, speed, and reliability for businesses of all sizes.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <p className="section-content">
                {' '}
                Our commitment to excellence and technical precision has made us
                a trusted partner for companies seeking efficient, scalable
                logistics solutions across global markets.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="about-features">
                <div className="about-feature-item">
                  <div className="about-feature-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                  </div>
                  <span>ISO Certified Operations</span>
                </div>
                <div className="about-feature-item">
                  <div className="about-feature-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                  </div>
                  <span>24/7 Support Team</span>
                </div>
                <div className="about-feature-item">
                  <div className="about-feature-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                  </div>
                  <span>Advanced Tracking Systems</span>
                </div>
              </div>
            </div>
            <div className="about-image-grid">
              <div className="about-image-card about-image-card-1">
                <img style={{objectPosition:'left'}}
                  // src="https://images.pexels.com/photos/906494/pexels-photo-906494.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                  src='https://www.zehinliyoldash.com/img/carousel-1.jpg'
                  alt="Colorful stacked shipping containers at a port exemplify global logistics."
                />
                <div className="about-image-overlay">
                  <span className="about-image-label">Global Network</span>
                </div>
              </div>
              <div className="about-image-card about-image-card-2">
                <img
                  src="https://images.pexels.com/photos/209251/pexels-photo-209251.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                  alt="Spacious and modern warehouse interior with parked truck and steel structures."
                />
                <div className="about-image-overlay">
                  <span className="about-image-label">Modern Facilities</span>
                </div>
              </div>
              <div className="about-image-card about-image-card-3">
                <img
                  src="https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                  alt="A warehouse worker maneuvers a forklift to transport crates for brewing company storage."
                />
                <div className="about-image-overlay">
                  <span className="about-image-label">Expert Team</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="services-section">
        <div className="services-container">
          <div className="services-header">
            <div className="services-header-left">
              <span className="section-label">OUR SERVICES</span>
              <h2 className="section-title">
                Complete Transportation Solutions
              </h2>
            </div>
            <p className="services-header-description">
              {' '}
              From air to ocean, rail to road – we provide integrated logistics
              services that keep your business moving forward with precision and
              reliability.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8L4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1l3 2l2 3l1-1v-3l3-2l3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2"
                      ></path>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>01</span>
                  </div>
                </div>
                <h3 className="service-title">Air Freight</h3>
                <p className="service-description">
                  {' '}
                  The fastest way to transportation from different countries is an international air freight. The terms and price of air freight depend on the type of the goods and distance, therefore they are calculated individually.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Express Delivery</span>
                  <span className="service-feature-tag">Global Coverage</span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M12 10.189V14m0-12v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"></path>
                        <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"></path>
                        <path d="M2 21c.6.5 1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>02</span>
                  </div>
                </div>
                <h3 className="service-title">Sea Freight</h3>
                <p className="service-description">
                  {' '}
                  Enjoy cost-efficiency when choosing a sea freight solution. Delivering of cargoes in containers guarantees their safety. Marine freight is used quite extensively for the movement of bulk and liquid commodities too.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">FCL &amp; LCL</span>
                  <span className="service-feature-tag">Port-to-Port</span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                        <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>03</span>
                  </div>
                </div>
                <h3 className="service-title">Rail Freight</h3>
                <p className="service-description">
                  {' '}
                  International railway transportation is suitable for the transportation of all categories of goods - bulk and oversized, food and raw materials which require special conditions. Depending on the type of cargo and the requirements for its transportation, different types of wagons can be used. It reduces supply chain costs, allowing the business to be more competitive in the global market.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Bulk Cargo</span>
                  <span className="service-feature-tag">Eco-Friendly</span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                        <circle cx="17" cy="18" r="2"></circle>
                        <circle cx="7" cy="18" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>04</span>
                  </div>
                </div>
                <h3 className="service-title">Road Freight</h3>
                <p className="service-description">
                  {' '}
                  International road transportation is one of the most demanded shipping modes. Fast delivery of your goods is carried out thanks to the widespread network of our reliable transport partners.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Last Mile</span>
                  <span className="service-feature-tag">
                    Temperature Control
                  </span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                        <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>05</span>
                  </div>
                </div>
                <h3 className="service-title">Customs Clearance</h3>
                <p className="service-description">
                  {' '}
                  Expert customs brokerage and compliance services to ensure
                  smooth border crossings and regulatory adherence.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Fast Processing</span>
                  <span className="service-feature-tag">Compliance</span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11"></path>
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8zM6 13h12M6 17h12"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>06</span>
                  </div>
                </div>
                <h3 className="service-title">Warehouse &amp; Storage</h3>
                <p className="service-description">
                  {' '}
                  State-of-the-art warehousing facilities with inventory
                  management, order fulfillment, and distribution services.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Secure Storage</span>
                  <span className="service-feature-tag">Fulfillment</span>
                </div>
              </div>
            </div>
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m3 11l19-9l-9 19l-2-8z"
                      ></path>
                    </svg>
                  </div>
                  <div className="service-number">
                    <span>07</span>
                  </div>
                </div>
                <h3 className="service-title">Freight Forwarding</h3>
                <p className="service-description">
                  {' '}
                  Comprehensive supply chain coordination, route optimization,
                  and multimodal transport planning for complex logistics.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="service-features">
                  <span className="service-feature-tag">Multimodal</span>
                  <span className="service-feature-tag">Route Planning</span>
                </div>
              </div>
            </div>
            <div className="service-card service-card-cta">
              <div className="service-card-inner">
                <h3 className="service-cta-title">Need a Custom Solution?</h3>
                <p className="service-cta-description">
                  {' '}
                  Our team can design tailored logistics strategies to meet your
                  unique business requirements.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <button className="btn btn-accent">Contact Us</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="why-choose" className="why-choose-section">
        <div className="why-choose-container">
          <div className="why-choose-header">
            <span className="section-label">WHY CHOOSE AWG</span>
            <h2 className="section-title">
              Built on Precision, Powered by Innovation
            </h2>
          </div>
          <div className="why-choose-grid">
            <div className="why-choose-card why-choose-card-highlight">
              <div className="why-choose-icon-container">
                <div className="why-choose-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    ></path>
                  </svg>
                </div>
              </div>
              <h3 className="why-choose-title">Lightning Speed</h3>
              <p className="why-choose-description">
                {' '}
                Express delivery options with optimized routes and priority
                handling ensure your shipments arrive on time, every time.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="why-choose-metric">
                <span className="metric-value">99.7%</span>
                <span className="metric-label">On-Time Delivery</span>
              </div>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon-container">
                <div className="why-choose-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    ></path>
                  </svg>
                </div>
              </div>
              <h3 className="why-choose-title">Unwavering Reliability</h3>
              <p className="why-choose-description">
                {' '}
                Decades of experience, redundant systems, and proven processes
                guarantee consistent, dependable service.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="why-choose-metric">
                <span className="metric-value">15+</span>
                <span className="metric-label">Years Trusted</span>
              </div>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon-container">
                <div className="why-choose-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <h3 className="why-choose-title">Global Reach</h3>
              <p className="why-choose-description">
                {' '}
                Extensive network spanning continents with local expertise and
                global coordination capabilities.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="why-choose-metric">
                <span className="metric-value">80+</span>
                <span className="metric-label">Countries</span>
              </div>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon-container">
                <div className="why-choose-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34M4 6h.01M2.29 9.62a10 10 0 1 0 19.02-1.27"></path>
                      <path d="M16.24 7.76a6 6 0 1 0-8.01 8.91M12 18h.01m5.98-6.34a6 6 0 0 1-2.22 5.01"></path>
                      <circle cx="12" cy="12" r="2"></circle>
                      <path d="m13.41 10.59l5.66-5.66"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <h3 className="why-choose-title">Real-Time Tracking</h3>
              <p className="why-choose-description">
                {' '}
                Advanced GPS tracking and digital dashboards provide complete
                visibility throughout the entire shipping journey.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="why-choose-metric">
                <span className="metric-value">24/7</span>
                <span className="metric-label">Live Updates</span>
              </div>
            </div>
            <div className="why-choose-card">
              <div className="why-choose-icon-container">
                <div className="why-choose-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </g>
                  </svg>
                </div>
              </div>
              <h3 className="why-choose-title">Custom Solutions</h3>
              <p className="why-choose-description">
                {' '}
                Flexible service packages tailored to your specific industry,
                cargo type, and delivery requirements.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="why-choose-metric">
                <span className="metric-value">100%</span>
                <span className="metric-label">Customizable</span>
              </div>
            </div>
            <div className="why-choose-card why-choose-card-image">
              <img
                src="https://images.pexels.com/photos/163726/belgium-antwerp-shipping-container-163726.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                alt="Colorful shipping containers stacked in a harbor, symbolizing global trade."
              />
              <div className="why-choose-image-overlay">
                <div className="why-choose-image-content">
                  <h4>Ready to Ship?</h4>
                  <button className="btn btn-accent">Get Started</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="clients" className="clients-section">
        <div className="clients-container">
          <div className="clients-header">
            <span className="section-label">TRUSTED PARTNERS</span>
            <h2 className="section-title">
              Companies That Trust AWG Logistics
            </h2>
          </div>
          <div className="clients-grid">
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo1} width={100}/>
              </div>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo2} width={100}/>
              </div>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo3} width={100}/>
              </div>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo4} width={100}/>
              </div>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo1} width={100}/>
              </div>
            </div>
            <div className="client-logo-card">
              <div className="client-logo-placeholder">
                  <img src={logo2} width={100}/>
              </div>
            </div>
          </div>
          <div className="testimonials-container">
            <div className="testimonial-card">
              <div className="testimonial-quote-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"></path>
                </svg>
              </div>
              <p className="testimonial-text">
                {' '}
                &quot;AWG Logistics transformed our supply chain. Their
                reliability and transparency have been game-changing for our
                international operations.&quot;
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="testimonial-author">
                <div className="testimonial-author-name">
                  <span>Michael Chen</span>
                </div>
                <div className="testimonial-author-title">
                  <span>
                    {' '}
                    Supply Chain Director, TechCorp Global
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-quote-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"></path>
                </svg>
              </div>
              <p className="testimonial-text">
                {' '}
                &quot;The real-time tracking system and professional team make
                AWG our go-to logistics partner. They consistently exceed
                expectations.&quot;
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="testimonial-author">
                <div className="testimonial-author-name">
                  <span>Sarah Rodriguez</span>
                </div>
                <div className="testimonial-author-title">
                  <span>
                    {' '}
                    Operations Manager, Global Imports Inc
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-quote-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"></path>
                </svg>
              </div>
              <p className="testimonial-text">
                {' '}
                &quot;Fast, efficient, and cost-effective. AWG Logistics handles
                our most critical shipments with precision and care.&quot;
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="testimonial-author">
                <div className="testimonial-author-name">
                  <span>James Kumar</span>
                </div>
                <div className="testimonial-author-title">
                  <span>
                    {' '}
                    CEO, ManufacturePro Solutions
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <div className="contact-grid">
            <div className="contact-info-block">
              <div className="section-header">
                <span className="section-label">GET IN TOUCH</span>
                <h2 className="section-title">Request Your Custom Quote</h2>
              </div>
              <p className="section-content">
                {' '}
                Ready to optimize your logistics? Contact our expert team for a
                personalized consultation and competitive quote tailored to your
                business needs.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      ></path>
                    </svg>
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Phone</span>
                    <span className="contact-info-value">
                      +1 (555) 123-4567
                    </span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Email</span>
                    <span className="contact-info-value">
                      info@atlaswayglobal.com
                    </span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                      ></path>
                    </svg>
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Address</span>
                    <span className="contact-info-value">
                      {' '}
                      1234 Logistics Blvd, Global City, GC 12345
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M12 6v6l4 2"></path>
                        <circle cx="12" cy="12" r="10"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Hours</span>
                    <span className="contact-info-value">
                      24/7 Operations Support
                    </span>
                  </div>
                </div>
              </div>
              <div className="contact-features">
                <div className="contact-feature-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>Fast Response Time</span>
                </div>
                <div className="contact-feature-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>No Obligation Quotes</span>
                </div>
                <div className="contact-feature-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>Expert Consultation</span>
                </div>
              </div>
            </div>
            <div className="contact-form-block">
              <form id="contactForm" className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">
                      Full Name
                    </label>
                    <div className="form-input-wrapper">
                      <div className="form-input-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </g>
                        </svg>
                      </div>
                      <input
                        type="text"
                        id="name"
                        name="true"
                        placeholder="John Doe"
                        required="true"
                        className="form-input"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">
                      Phone Number
                    </label>
                    <div className="form-input-wrapper">
                      <div className="form-input-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                          ></path>
                        </svg>
                      </div>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="+1 (555) 000-0000"
                        required="true"
                        className="form-input"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <div className="form-input-wrapper">
                    <div className="form-input-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                          <rect
                            width="20"
                            height="16"
                            x="2"
                            y="4"
                            rx="2"
                          ></rect>
                        </g>
                      </svg>
                    </div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="john@company.com"
                      required="true"
                      className="form-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    {' '}
                    Message / Requirements
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </label>
                  <div className="form-textarea-wrapper">
                    <div className="form-input-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                        ></path>
                      </svg>
                    </div>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      placeholder="Tell us about your shipping needs, cargo type, destination, and timeline..."
                      required="true"
                      className="form-textarea"
                    ></textarea>
                  </div>
                </div>
                <button
                  type="submit"
                  className="form-submit-btn btn btn-accent btn-lg"
                >
                  {' '}
                  Send Inquiry
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </button>
              </form>
              <div className="contact-map-container">
                <div className="contact-map-placeholder">

                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6291.496061644438!2d58.32536898255627!3d37.95966893082232!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f7001ba67657855%3A0x811c1f38119b762e!2szehinli%20yoldash%20logistics!5e0!3m2!1sru!2s!4v1760347738996!5m2!1sru!2s" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    ></path>
                  </svg>
                  <p>Global Headquarters Location</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  )
}

export default Home
